/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Jsx from './poll_list_item.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const worker = global.rootRequire('classes/globalUser')
// const workerContacts = global.rootRequire('classes/globalContacts')
const chatDB = global.rootRequire('classes/indexedDB').default
const {rxaget} = global.rootRequire('classes/ulti')
class RxPollListItem_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      user_created:{}
      
    }
    this.token = rxaget(this.props, 'netaauth.user.token', '')
  }
  componentDidMount(){
    this.getCreatorInfo()
  }


  async getCreatorInfo(){
    let poll_id = this.props.pollInfo.poll_id
    let pollInfo = this.props.pollInfo
    if(pollInfo && pollInfo.user_created){
      pollInfo = this.props.pollInfo
    }else{
      pollInfo = await this.getPollById(poll_id)
    }
    let memberId = pollInfo.user_created.Id
    let userInDB = await worker.users[memberId]
    let user_created = {...userInDB}
    // let contactInDB = await workerContacts.contacts[userInDB.phone] 
    let contactInDB = await chatDB.contacts.get(userInDB.phone)
    user_created.group_fullname = (userInDB && contactInDB && contactInDB.name) ? contactInDB.name : (userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''
    
    this.setState({user_created:user_created})
    
  }
  async getPollById(poll_id){
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.token }
    let pollInfo = await fetch(global.rxu.get(global.rxu.config, 'api_get_poll')+poll_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })

    return pollInfo.json()
  }

  choosePoll(pollInfo){
    let elem = document.getElementById('chat-value')
    let data= pollInfo
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chatInput', { detail: { data: data, scroll: true ,cond :'', type:'choosePoll'}}))
    }
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth,
  rxChangePolls:state.rxChangePolls,
})

const mapDispatchToProps = {

}

const RxPollListItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxPollListItem_)

export default RxPollListItem

